export enum ProductBoughtStatusEnum {
  contracted = 2,
  cancelled = 3,
}
